import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortalNotFoundViewComponent } from './views/portal-notfound-view/portal-notfound-view.component';
import { AppComponent } from './app.component';
import { PortalLoginViewComponent } from './views/portal-login-view/portal-login-view.component';
import { PortalWelcomeViewComponent } from './views/portal-welcome-view/portal-welcome-view.component';
import { PortalLogoutViewComponent } from './views/portal-logout-view/portal-logout-view.component';
import { AuthGuardService } from './services/auth-guard-service/auth-guard.service';
import { PortalMyActivityViewComponent } from './views/portal-myactivity-view/portal-myactivity-view.component';
import { PortalMyDetailsViewComponent } from './views/portal-mydetails-view/portal-mydetails-view.component';
import { PortalMyBirthPlanViewComponent } from './views/portal-mybirthplan-view/portal-mybirthplan-view.component';
import { PortalMyEpaViewComponent } from './views/portal-myepa-view/portal-myepa-view.component';
import { PortalContactViewComponent } from './views/portal-contact-view/portal-contact-view.component';
import { PortalAdminSearchViewComponent } from './views/portal-admin-search-view/portal-admin-search.component';
import { PortalAdminViewComponent } from './views/portal-admin-view/portal-admin.component';
import { PortalRegistrationViewComponent } from './views/portal-registration-view/portal-registration-view.component';
import { PortalContactAdminComponent } from './views/portal-admin-contact/portal-contact-admin/portal-contact-admin.component';
import { PortalResetPasswordComponent } from './views/portal-reset-password/portal-reset-password.component';
import { PortalNewPasswordComponent } from './views/portal-new-password/portal-new-password.component';
import { PortalHomeViewComponent } from './views/portal-home-view/portal-home-view.component';
import { PortalAdminPatientViewComponent } from './views/portal-admin-patient-view/portal-admin-patient-view.component';
import { PortalActivityViewComponent } from './views/portal-activity-view/portal-activity-view.component';
import { ChangePasswordComponent } from './views/portal-change-password/change-password/change-password.component';
import { UsefulWebsite } from './models/useful-website';
import { PortalUsefulWebsiteViewComponent } from './views/portal-useful-website-view/portal-useful-website-view.component';
import { PortalAdminCardsViewComponent } from './views/portal-admin-cards-view/portal-admin-cards-view.component';
import { PortalAdminReportConfigComponent } from './views/portal-admin-report-config/portal-admin-report-config.component';

const appRoutes: Routes = [
  {
    path: 'app',
    children: [
      {
        path: 'registration',
        component: PortalRegistrationViewComponent
      },
      {
        path: 'newpassword',
        component: PortalNewPasswordComponent
      },
      {
        path: 'changepassword',
        component: ChangePasswordComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'welcome',
        component: PortalWelcomeViewComponent
      },
      {
        path: 'aboutme',
        component: PortalMyDetailsViewComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: 'activity',
        component: PortalActivityViewComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: 'mybirthplan',
        component: PortalMyBirthPlanViewComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: 'mypregnancy',
        component: PortalMyEpaViewComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: 'contact',
        component: PortalContactViewComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: 'login',
        component: PortalLoginViewComponent
      },
      {
        path: 'logout',
        component: PortalLogoutViewComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'home',
        component: PortalHomeViewComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'reset',
        component: PortalResetPasswordComponent,
      },
      {
        path: 'admin',
        canActivate: [AuthGuardService],
        children: [
          {
            path: 'search',
            component: PortalAdminSearchViewComponent,
          },
          {
            path: 'patient',
            component: PortalAdminPatientViewComponent,
          },
          {
            path: 'details',
            component: PortalAdminViewComponent,
          },
          {
            path: 'contact',
            component: PortalContactAdminComponent,
          },
          {
            path: 'websites',
            component: PortalUsefulWebsiteViewComponent,
          },
          {
            path: 'report-configuration',
            component: PortalAdminReportConfigComponent,
          },
          {
            path: 'card-configuration',
            component: PortalAdminCardsViewComponent,
          }
        ]
      },
      {
        path: '',
        redirectTo: 'welcome',
        pathMatch: 'full'
      },
    ]
  },
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: PortalNotFoundViewComponent,
    // resolve: { ViewConfigService } User resolvers to get data for a particular view
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    )
    // other imports here
  ],
  providers: []
})
export class AppRoutingModule {

  // The AppConfig reads settings for a config.json file (TODO!)
  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts